module.exports = __webpack_public_path__ + "img/yearbook-recruitment.64ea5618.svg";